import { PfileTypeId } from '@lib2/model/pfile/PFileType';

// ── Image Spec (UI metadata only -- enum IDs come from lib2) ──
export interface PfileImageSpec {
  pfileTypeId: PfileTypeId;
  deletePfileTypeIds: PfileTypeId[];
  label: string;
  recommendedSize: string;
  aspectRatio: number;
  maxFileSizeMb: number;
}

export const APP_WEB_IMAGE_SPECS: PfileImageSpec[] = [
  {
    pfileTypeId: PfileTypeId.AppWebOHLogo,
    deletePfileTypeIds: [PfileTypeId.AppWebOHLogo],
    label: 'Logo',
    recommendedSize: '300 x 100',
    aspectRatio: 3,
    maxFileSizeMb: 5,
  },
  {
    pfileTypeId: PfileTypeId.AppWebSiteImg,
    deletePfileTypeIds: [PfileTypeId.AppWebSiteImg],
    label: 'Site Image',
    recommendedSize: '1200 x 630',
    aspectRatio: 1200 / 630,
    maxFileSizeMb: 10,
  },
  {
    pfileTypeId: PfileTypeId.AppWebIcon192,
    deletePfileTypeIds: [PfileTypeId.AppWebIcon192],
    label: 'App Icon',
    recommendedSize: '512 x 512',
    aspectRatio: 1,
    maxFileSizeMb: 5,
  },
];

export const CONTENT_IMAGE_SPECS: PfileImageSpec[] = [
  {
    pfileTypeId: PfileTypeId.ListPoster,
    deletePfileTypeIds: [PfileTypeId.ListPoster, PfileTypeId.ListThumb],
    label: 'Poster Image',
    recommendedSize: '1920 x 1080',
    aspectRatio: 16 / 9,
    maxFileSizeMb: 20,
  },
];

// ── Accepted Image Types ──
export const PFILE_ACCEPTED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
] as const;

export const PFILE_ACCEPTED_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  '.heic',
  '.heif',
] as const;

export const PFILE_PROCESSING_TIMEOUT_MS = 60_000;
